import { ol_extent } from "@omnia/exports/openlayers"
import { FieldViewModel, Datalayer, ExplorerContext, getDistinctValues, IDatalayersMap, ILayerViewModel, isArrayEmpty, LayerViewModel, LmNode, map } from "../omnia"
import { ContextMenuArguments, isFieldViewModel } from "./types"

export function getContextMenuArguments(context: ExplorerContext, tooltip: map.IMapTooltip): ContextMenuArguments {

    const { feature } = tooltip

    if (feature) {

        const data = feature.get("data")
        const l = feature.get("layer")


        const layer = (l instanceof Datalayer) ? context.getLayer(l.datalayerId) : undefined

        const fieldId = (l instanceof Datalayer) ? l.fieldId : undefined

        const field = fieldId
            ? context.getField(fieldId)
            : (isFieldViewModel(data) ? data : undefined)

        return {
            tooltip,
            context,
            field,
            layer
        }

    }

}

export function getLayerVisibilityToggleValue(layer: LayerViewModel, map: IDatalayersMap) {

    const field = layer.field

    function getLayerExtent() {
        return layer && layer.mapLayer && layer.zonesLoaded
            ? layer.getExtent()
            : (field ? map.getExtentForDataItem(field) : undefined)
    }

    const hide = layer.visible
        && isTopMostLayer(layer, field, map)
        && compareExtents(map.getCurrentViewExtent(), getLayerExtent())

    return !hide

}

function isTopMostLayer(layer: ILayerViewModel, field: FieldViewModel, map: IDatalayersMap) {

    const predicate = field
        ? (l: Datalayer) => l.fieldId == field.fieldId
        : (l: Datalayer) => true

    const top = map.getTopmostLayer(predicate)

    return top && (layer.datalayerId == top.datalayerId)

}

function compareExtents(a: number[], b: number[]) {

    if (a && b && a.length == b.length && ol_extent.containsExtent(a, b)) {

        const ca = ol_extent.getCenter(a)
        const cb = ol_extent.getCenter(b)

        return (ca[0] == cb[0]) && (ca[1] == cb[1])

    }

}


export function viewExtent(map: IDatalayersMap, node: LmNode) {

    const layers = node.flatten(n => n.layer).filter(l => l && l.zonesLoaded && l.visible)

    if (layers.length) {
        const extent = layers.map(l => l.getExtent()).reduce((a, b) => ol_extent.extend(a, b))
        map.viewExtent(extent)
        return
    }

    const { layer } = node

    const fields = getDistinctValues(node.flatten(n => n.field).filter(f => !!f), f => f, f => f.getId())

    if (!isArrayEmpty(fields)) {
        map.viewExtentForDataItems(fields)
    }

    if (layer) {
        layer.notifyOnLoad(l => map.viewExtent(l.getExtent()))
    }

    return layer

}
